"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const qrcode = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-qrcode` : '') + (description ? ` desc-qrcode` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-qrcode"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-qrcode"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "inherit",
    d: "M8.74 5.34c.38 0 .7.32.7.7v2.7a.7.7 0 0 1-.7.7h-2.7a.7.7 0 0 1-.7-.7v-2.7c0-.38.32-.7.7-.7zm-2 2.7h1.3v-1.3h-1.3zm2 6.74c.38 0 .7.31.7.7v2.7a.7.7 0 0 1-.7.7h-2.7a.7.7 0 0 1-.7-.7v-2.7c0-.39.32-.7.7-.7zm-2 2.7h1.3v-1.3h-1.3zM18.17 5.34c.39 0 .7.32.7.7v2.7a.7.7 0 0 1-.7.7h-2.7a.7.7 0 0 1-.7-.7v-2.7c0-.38.32-.7.7-.7zm-2 2.7h1.3v-1.3h-1.3zm-5.44 6.09v-.65H6.04a.7.7 0 0 1 0-1.4h5.4c.38 0 .7.31.7.7v1.35a.7.7 0 0 1-1.4 0m7.43-.7c.39 0 .7.31.7.7v4.04a.7.7 0 0 1-.7.7h-4.04a.7.7 0 0 1-.7-.7v-4.04a.7.7 0 0 1 1.4 0v3.34h2.64v-2.64h-.65a.7.7 0 0 1 0-1.4zm-7.44 4.74v-1.35a.7.7 0 0 1 1.4 0v1.35a.7.7 0 0 1-1.4 0m0-12.13a.7.7 0 0 1 1.4 0V9.4h.65a.7.7 0 0 1 0 1.4h-1.35a.7.7 0 0 1-.7-.7zm7.44 4.69a.7.7 0 0 1 0 1.4h-2.7a.7.7 0 0 1 0-1.4zM1 6.72V3.35A2.35 2.35 0 0 1 3.35 1h3.37a1 1 0 0 1 0 2H3.35a.35.35 0 0 0-.35.35v3.37a1 1 0 0 1-2 0m20.21 0V3.35a.35.35 0 0 0-.34-.35H17.5a1 1 0 0 1 0-2h3.37a2.35 2.35 0 0 1 2.34 2.35v3.37a1 1 0 1 1-2 0m0 14.15V17.5a1 1 0 0 1 2 0v3.37a2.35 2.35 0 0 1-2.34 2.34H17.5a1 1 0 0 1 0-2h3.37a.35.35 0 0 0 .34-.34M1 20.87V17.5a1 1 0 0 1 2 0v3.37a.35.35 0 0 0 .35.34h3.37a1 1 0 0 1 0 2H3.35A2.35 2.35 0 0 1 1 20.87"
  }));
};
var _default = exports.default = qrcode;